<template>
  <el-input
    v-bind="$attrs"
    step="any"
    :modelValue="modelValue"
    type="number"
    @change="onChangeHandeler"
    @input="onInputHandler"
    @update:modelValue="onUpdateHandler"
    :input-style="{'text-align': 'right'} "
  ></el-input>
</template>

<script>
export default {
  props: {
    modelValue: [String, Number],
    max: Number,
    min: Number,
    notCheckInput:Boolean
  },
  data() {
    return {
      textNumber: null,
      previousNumber: null,
      numRegex: /^[0-9]*\.?[0-9]*$/,
    };
  },
  // computed: {
  //   textNumber: {
  //     get() {
  //       return this.modelValue
  //     },
  //     set(newValue) {
  //       console.log(newValue)
  //       const val = parseFloat(newValue.replaceAll(",", ""))
  //       if(isNaN(val)) {
  //         return
  //       }

  //       return this.$emit("update:modelValue", val)
  //     }
  //   }
  // },
  methods: {
    onChangeHandeler(num) {
      //console.log(this.min ,  num,Number(this.min) > Number(num))
      if(this.min && Number(this.min) > Number(num)) {
        this.$emit("update:modelValue", Math.round(this.min * 100) / 100 );
      }
    },
    onInputHandler(num) {
      // console.log(this.max && this.max < num,this.max ,num)
      if(this.max && this.max < num && !this.notCheckInput) {
        this.$emit("update:modelValue", this.max);
      }
      
      // console.log('input', num);
      // return num;
    },
    onUpdateHandler(num) {
      this.$emit("update:modelValue", num);
    }
    // validate(num) {
    //   return num.toString().replaceAll(",", '').match(this.numRegex);
    // }
  },
};
</script>
